import { useEffect, useState } from "react";

import Select from "react-select";
import swal from "sweetalert";
import { PropertyMappingDelete, getBasicPropertydetails, ReservationMealplan, ReservationRateCodeList, ReservationMAppingList, ResRoomlist, ReservationSaveMapping } from "../../Services/Service";
import ReservationSidebar from "../Commun/ReservationSidebar";
import ReservationHeader from "../Commun/ReservationHeader";
import { useProperty } from "../../PropertyContext";

export const ReservationRateInventory = () => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [mappinglist, setMappingList] = useState([]);
    const [ratecode, setRatecode] = useState([]);
    const [mealplan, setMealplan] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [selectedRate, setSelectedRate] = useState("");
    const [selectedMealPlan, setSelectedMealPlan] = useState("");
    const [selectedRoom, setSelectedRoom] = useState("");

    const [baseRate, setBaseRate] = useState(0);
    const [doubleRate, setDoubleRate] = useState(0);
    const [tripleRate, setTripleRate] = useState(0);
    const [extraBed, setExtraBed] = useState(0);
    const [extraAdultRate, setExtraAdultRate] = useState(0);
    const [extraChildRate, setExtraChildRate] = useState(0);
    const [effectiveFrom, setEffectiveFrom] = useState("");
    const [effectiveTo, setEffectiveTo] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [editId, setEditId] = useState(0);
    const [Pms, setPMS] = useState();

    const [filteredList, setFilteredList] = useState([]);

    // rate code

    const fetchMappingList = async (rateCodeId) => {
        setLoading(true);
        try {
            const result = await ReservationMAppingList(rateCodeId, selectedProperty?.PropertyID);
            if (Array.isArray(result)) setMappingList(result);
            else setMappingList([]);
        } catch (error) {
            console.log("Error fetching mapping list", error);
            setMappingList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const FetchRatecode = async () => {
            setLoading(true);
            try {
                const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    setRatecode(result);

                    const firstRateCodeId = result.length > 0 ? result[0].RateCodeID : 0;

                    // Now call mapping list API with that rate code id
                    fetchMappingList(firstRateCodeId);
                } else {
                    // if not array, call mapping list with 0
                    fetchMappingList(0);
                }
            }
            catch (error) {
                console.log("error get rate code", error);
                fetchMappingList(0);
            } finally {
                setLoading(false);
            }
        }
        FetchRatecode();
    }, [selectedProperty]);


    // meal paln
    useEffect(() => {
        const FetchMealplan = async () => {
            setLoading(true);
            try {
                const result = await ReservationMealplan(selectedProperty?.PropertyID);
                if (Array.isArray(result)) setMealplan(result);
            }
            catch (error) {
                console.log("error get meal plan", error);
            } finally {
                setLoading(false);
            }
        }
        FetchMealplan();
    }, [selectedProperty]);

    // room name 
    useEffect(() => {
        const fetchRoomData = async () => {
            setLoading(true);
            try {
                const data = await ResRoomlist(selectedProperty?.PropertyID);
                if (data && Array.isArray(data.RoomsDetails)) {
                    setRooms(data.RoomsDetails);
                } else {
                    setRooms([]);
                }
            } catch (error) {
                console.error("Room data fetch error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRoomData();
    }, [selectedProperty]);

    const handleAdd = () => {
        setEditId(0);
        setSelectedRate("");
        setSelectedMealPlan("");
        setSelectedRoom("");
        setBaseRate(0);
        setDoubleRate(0);
        setTripleRate(0);
        setExtraBed(0);
        setExtraAdultRate(0);
        setExtraChildRate(0);
        setEffectiveFrom("");
        setEffectiveTo("");
        setIsActive(1);
    };

    // Open modal for edit
    const handleEdit = (item) => {
        setEditId(item.RateCodeMealPlanID);
        setSelectedRate(item.RateCodeID);
        setSelectedMealPlan(item.MealPlanID);
        setSelectedRoom(item.RoomTypeID);
        setBaseRate(item.BaseRate);
        setDoubleRate(item.DoubleRate);
        setTripleRate(item.TripleRate);
        setExtraBed(item.ExtraBed);
        setExtraAdultRate(item.ExtraAdultRate);
        setExtraChildRate(item.ExtraChildRate);
        setEffectiveFrom(item.EffectiveFrom.split("T")[0]);
        setEffectiveTo(item.EffectiveTo.split("T")[0]);
        setIsActive(item.IsActive === 1);
    };

    // Submit handler
    const handleSubmit = async () => {
        if (!selectedMealPlan || !selectedRoom) {
            swal("Error", "Please select Rate, Meal Plan and Room", "error");
            return;
        }
        try {
            setLoading(true);

            await ReservationSaveMapping(
                selectedProperty?.PropertyID || 0,
                editId,
                selectedRate || 0,
                selectedMealPlan,
                selectedRoom,
                baseRate,
                doubleRate,
                tripleRate,
                extraBed,
                extraAdultRate,
                extraChildRate,
                effectiveFrom,
                effectiveTo,
                isActive ? 1 : 0
            );

            // refresh table
            const result = await ReservationMAppingList(1, selectedProperty?.PropertyID);
            if (Array.isArray(result)) setMappingList(result);

            // show success alert
            swal("Data saved successfully!", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                // close modal
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("example-modal-lg")
                );
                if (modal) modal.hide();

                // reset form fields
                setSelectedRate("");
                setSelectedMealPlan("");
                setSelectedRoom("");
                setBaseRate("");
                setDoubleRate("");
                setTripleRate("");
                setExtraBed("");
                setExtraAdultRate("");
                setExtraChildRate("");
                setEffectiveFrom("");
                setEffectiveTo("");
                setIsActive(true);
                setEditId(0);
            });

        } catch (error) {
            console.log("Error saving mapping", error);
            swal("Failed to save data!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };


    const handleDelete = async (RateCodeMealPlanID) => {
        setLoading(true);
        try {
            const confirm = await swal({
                title: "Are you sure?",
                icon: "warning",
                buttons: {
                    cancel: "Cancel",
                    confirm: {
                        text: "Delete",
                        value: true,
                        visible: true,
                        className: "btn-danger",
                        closeModal: true,
                    },
                },
                dangerMode: true,
            });

            if (confirm) {
                await PropertyMappingDelete(RateCodeMealPlanID);

                // state update without refetch
                setMappingList((prev) =>
                    prev.filter((item) => item.RateCodeMealPlanID !== RateCodeMealPlanID)
                );

                swal("Mapping deleted successfully!", {
                    icon: "success",
                });
            }
        } catch (error) {
            console.log("error deleting mapping", error);
            swal("Failed to delete mapping!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };


    const formatOptions = (list, labelKey, valueKey) => {
        return list.map((item) => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    };

    useEffect(() => {
        setFilteredList(mappinglist);
    }, [mappinglist]);

    // Filter handler
    const handleFilter = (e) => {
        e.preventDefault();
        setLoading(true);

        let temp = mappinglist;

        if (selectedRate) {
            temp = temp.filter((item) => item.RateCodeID === Number(selectedRate));
        }
        if (selectedRoom) {
            temp = temp.filter((item) => item.RoomTypeID === Number(selectedRoom));
        }
        if (selectedMealPlan) {
            temp = temp.filter((item) => item.MealPlanID === Number(selectedMealPlan));
        }


        // from & to date filter
        if (effectiveFrom) {
            temp = temp.filter((item) => item.EffectiveFrom.split("T")[0] >= effectiveFrom);
        }
        if (effectiveTo) {
            temp = temp.filter((item) => item.EffectiveTo.split("T")[0] <= effectiveTo);
        }

        setFilteredList(temp);

        setLoading(false);
    };

    // Clear handler
    const handleClear = () => {
        setSelectedRate("");
        setSelectedRoom("");
        setSelectedMealPlan("");
        setEffectiveFrom("");
        setEffectiveTo("");
        setFilteredList(mappinglist);
    };

    useEffect(() => {
        const FetchPMS = async () => {
            try {
                const result = await getBasicPropertydetails();
                if (result && result.length > 0) {
                    setPMS(result[0]);
                }
            }
            catch (error) {
                console.log("error fetch Pms in get api", error);
            }
        }
        FetchPMS();
    }, [])

    return (

        <>
            <style>{`
           .form-control{
            border-width: 1px !important;
            border-color: hsl(0, 0%, 80%);
           }   
        `}</style>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Rate Inventory List</h4>
                                        </div>
                                        <div className="card-body">
                                            <form className="mb-0" onSubmit={handleFilter}>
                                                <div className="row">
                                                    {Pms?.PMS === "Opera" && (
                                                        <div className="col-sm-2">
                                                            <div className="mb-3">
                                                                <label className="form-label"> Rate Code</label>

                                                                <Select
                                                                    options={formatOptions(ratecode, "Name", "RateCodeID")}
                                                                    value={
                                                                        selectedRate
                                                                            ? {
                                                                                label:
                                                                                    ratecode.find((r) => r.RateCodeID === selectedRate)?.Name ||
                                                                                    "",
                                                                                value: selectedRate,
                                                                            }
                                                                            : null
                                                                    }
                                                                    onChange={(e) => setSelectedRate(e ? e.value : "")}
                                                                    placeholder="Select code"
                                                                    isClearable

                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> Room Name</label>

                                                            <Select
                                                                options={formatOptions(rooms, "RoomName", "RoomID")}
                                                                value={
                                                                    selectedRoom
                                                                        ? {
                                                                            label:
                                                                                rooms.find((r) => r.RoomID === selectedRoom)?.RoomName ||
                                                                                "",
                                                                            value: selectedRoom,
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(e) => setSelectedRoom(e ? e.value : "")}
                                                                placeholder="Select room"
                                                                isClearable
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> Meal Plan</label>

                                                            <Select
                                                                options={formatOptions(mealplan, "Name", "MealPlanID")}
                                                                value={
                                                                    selectedMealPlan
                                                                        ? {
                                                                            label:
                                                                                mealplan.find((m) => m.MealPlanID === selectedMealPlan)
                                                                                    ?.Name || "",
                                                                            value: selectedMealPlan,
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(e) => setSelectedMealPlan(e ? e.value : "")}
                                                                placeholder="Select plan"
                                                                isClearable
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> From</label>
                                                            <input type="date" className="form-control" value={effectiveFrom}
                                                                onChange={(e) => setEffectiveFrom(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> To</label>
                                                            <input type="date" className="form-control" value={effectiveTo}
                                                                onChange={(e) => setEffectiveTo(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div style={{ marginTop: "27px" }}>
                                                            <button className="btn btn-primary me-2">Filter</button>
                                                            <button className="btn btn-danger" onClick={handleClear}>Clear</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <div className="text-end mb-2">
                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#example-modal-lg" onClick={handleAdd}>Add</button>

                                                </div>
                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            {Pms?.PMS === "Opera" && (<th>Rate Code</th>)}
                                                            <th>Room Name</th>
                                                            <th>Meal Plan</th>
                                                            <th>Base Rate</th>
                                                            <th>From</th>
                                                            <th>To</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {filteredList.length > 0 ? (
                                                            filteredList.map((item) => (
                                                                <tr key={item.RateCodeMealPlanID}>
                                                                    {Pms?.PMS === "Opera" && (<td>{item.RateCodeName}</td>)}
                                                                    <td>{item.RoomName}</td>
                                                                    <td>{item.MealPlanName}</td>
                                                                    <td>₹ {item.BaseRate}</td>
                                                                    <td>{item.EffectiveFrom.split("T")[0]}</td>
                                                                    <td>{item.EffectiveTo.split("T")[0]}</td>
                                                                    <td>
                                                                        {item.IsActive ? (
                                                                            <span className="badge bg-success">Active</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">Inactive</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary btn-sm px-2 py-1 me-2"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#example-modal-lg"
                                                                            onClick={() => handleEdit(item)}
                                                                        >
                                                                            <i className="fas fa-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger py-1 px-2 btn-sm"
                                                                            onClick={() => handleDelete(item.RateCodeMealPlanID)}
                                                                        >
                                                                            <i className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center">
                                                                    No records found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>


                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <>
                        {/*  Modal */}
                        <div
                            className="modal fade"
                            id="example-modal-lg"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myLargeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            {editId === 0 ? "Add Rates" : "Edit Rates"}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            {Pms?.PMS === "Opera" && (
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Rate code</label>
                                                        <select className="form-control form-select" value={selectedRate}
                                                            onChange={(e) => setSelectedRate(e.target.value)} >
                                                            <option>Select code</option>
                                                            {ratecode.map((item) => (
                                                                <option key={item.RateCodeID} value={item.RateCodeID}>
                                                                    {item.Name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Meal Plan</label>
                                                    <select className="form-control form-select" value={selectedMealPlan}
                                                        onChange={(e) => setSelectedMealPlan(e.target.value)}>
                                                        <option>Select Plan</option>
                                                        {mealplan.map((item) => (
                                                            <option key={item.MealPlanID} value={item.MealPlanID}>
                                                                {item.Name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Room Name</label>
                                                    <select className="form-control form-select" value={selectedRoom}
                                                        onChange={(e) => setSelectedRoom(e.target.value)}>
                                                        <option>Select Room</option>
                                                        {rooms.map((room) => (
                                                            <option key={room.RoomID} value={room.RoomID}>
                                                                {room.RoomName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Base Rate</label>
                                                    <input type="number" className="form-control" value={baseRate}
                                                        min={0}
                                                        onChange={(e) => setBaseRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Double rate</label>
                                                    <input className="form-control" type="number" min={0} value={doubleRate} onChange={(e) => setDoubleRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Triple rate</label>
                                                    <input className="form-control" type="number" min={0} value={tripleRate} onChange={(e) => setTripleRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Extra bed</label>
                                                    <input className="form-control" type="number" min={0} value={extraBed} onChange={(e) => setExtraBed(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Extra Adult rate</label>
                                                    <input type="number" className="form-control" value={extraAdultRate}
                                                        min={0}
                                                        onChange={(e) => setExtraAdultRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Extra Child Rate</label>
                                                    <input type="number" className="form-control" value={extraChildRate}
                                                        min={0}
                                                        onChange={(e) => setExtraChildRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Efactive From</label>
                                                    <input type="date" className="form-control" value={effectiveFrom}
                                                        onChange={(e) => setEffectiveFrom(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Effactive To</label>
                                                    <input type="date" className="form-control" value={effectiveTo}
                                                        onChange={(e) => setEffectiveTo(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="mb-3 d-flex">
                                                    <label className="form-label me-2">Active</label>
                                                    <input type="checkbox" style={{ marginTop: "-7px" }} checked={isActive}
                                                        onChange={(e) => setIsActive(e.target.checked)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-primary btn-sm" onClick={handleSubmit}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Modal */}
                    </>

                </div>

            </div >
        </>
    )
}
